import React, { useRef } from "react";
import layoutStyle from "./layoutStyle";
import Footer from "../../components/Footer/Footer";
import ReleaseInfo from "../../components/ReleaseInfo/ReleaseInfo";
import ScrollTopButton from "../../components/Button/ScrollTopButton";
import { useCustomer } from "../../provider/Customer/CustomerProvider";
import { Box } from "@mui/material";
import { useFlexServiceLayoutForCustomer } from "../../services/advocardService";
import SkipLink from "@/src/components/SkipLink/SkipLink";
import { LayoutHeaderDefault } from "@/src/containers/Layouts/LayoutHeaderDefault";
import { LayoutHeaderAuthenticated } from "@/src/containers/Layouts/LayoutHeaderAuthenticated";

type LayoutProps = {
  minimal?: boolean;
  clickableLogo?: boolean;
  backgroundType?: "homepage" | "serviceworld" | "landingpage"; // TODO: Remove;
  children?: React.ReactNode;
  withScrollToTopButton?: boolean;
};

export default function Layout({ minimal = false, clickableLogo = true, backgroundType, children, withScrollToTopButton = true }: LayoutProps) {
  const skipLinkRef = useRef<HTMLAnchorElement>(null);
  const { customer } = useCustomer();

  const hideNavigation = useFlexServiceLayoutForCustomer(customer);

  return (
    <>
      <ReleaseInfo />
      <Box sx={layoutStyle.pageContainer}>
        <Box sx={layoutStyle.content}>
          <SkipLink ref={skipLinkRef} />
          {!!customer ? <LayoutHeaderAuthenticated /> : <LayoutHeaderDefault clickableLogo={clickableLogo} minimal={minimal} />}
          <Box component={"main"} sx={layoutStyle.childrenContainer} id={"main-content"}>
            {children}
          </Box>
          {withScrollToTopButton && <ScrollTopButton skipLinkRef={skipLinkRef} />}
          <Footer hideProductLinks={hideNavigation} />
        </Box>
      </Box>
    </>
  );
}
